import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Subject } from 'rxjs';
import { IntegrationService } from './integration.service';

@Injectable()
export class KnowledgeRepositoryService {

  knowledgeRepositoryEvent: EventEmitter<Object> = new EventEmitter();
  previewPageExitEvent: EventEmitter<object> = new EventEmitter();
  selectedDataEvent: EventEmitter<object> = new EventEmitter();
  openKnowledgeRepoEvent: EventEmitter<object> = new EventEmitter();
  knowledgeRepositoryDeleteEvent: EventEmitter<object> = new EventEmitter();

  closeAnnotatorEvent = new Subject<any>();
  knowledgeRepoSaveEvent = new Subject<any>();
  showSyncReport: any = false;

  constructor(
    private http: HttpClient,
    private _integrationService: IntegrationService
  ) { }

  getKnowledgeRepoType(){
    if(this._integrationService.oracleEnabled){
      return 'oracle/'
    }else if(this._integrationService.sharepointEnabled){
      return 'sharepoint/'
    }
  }

  anyKnowledgeIntegrationEnabled(){
    if (this._integrationService.oracleEnabled || this._integrationService.sharepointEnabled){
      return true
    } else {return false}
  }

  SearchOracleArticle(agentId, articleId) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/get_article/' +  articleId)           
  }

  saveToDraft(agentId, articleId,  params) {
    return this.http.post(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/' + 
    articleId + '/save_draft', params)
  }

  synchOracleData(agentId) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/oracle/' + agentId + '/sync_knowledge_repo')
  }

  searchOracleArticleId(agentId, searchKey) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId +
     '/articles/search?word=' + searchKey)
  }

  getSelectedId(agentId, articleId, params) {
    return this.http.post(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/' + articleId +
     '/get_cog_marks' , params)
  }


  deleteCogMarkStatus(agentId, articleId, cogMarkId, params) {
    return this.http.post(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/' + articleId + '/' +
     cogMarkId + '/is_deletable', params)
  }

  getCogMarkReference(agentId, articleId, cogMarkId) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/cog_mark_reference/'
     + articleId + '/' + cogMarkId)
  }

  getIngestedFeaterList(agentId, topicUri) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType()  + agentId + '/get_knowledge_reference_list/'
     + topicUri)
  }

  getIngestedSubFeaterList(agentId, topicUri, featureUri) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/get_knowledge_reference_list/'
     + topicUri + '/' + featureUri)
  }

  getIngestedMultiTopicList(agentId, topicUri, featureUri) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType()  + agentId + '/get_knowledge_reference_list/'
     + topicUri + '/' + featureUri + '?node=multi_topic')
  }

  getMappedArticleId(agentId, params) {
    return this.http.post(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/get_topic_feature_mapping',
    params)
  }

  getSyncStatus(agentId, params) {
    return this.http.post(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/get_sync_status',
    params)
  }

  deleteCogMarkReference(agentId, params) {
    return this.http.put(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/delete_reference',
     params)
  }

  updateArticleId(agentId, params) {
    return this.http.post(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/update_reference', params)
  }

  getPreviousContent(agentId, params) {
    return this.http.post(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/get_mappings_previous_data', params)
  }

  getOracleData(agentId, params) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/download_report', params);
  }

  getSyncMetaData(agentId) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/sync_metadata' )
  }
  getSyncReportData(agentId) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/sync_info' )
  }

  getSyncHistoryMetadata(agentId) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/sync_history')
  }

  synchSharepointData(agentId) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/sharepoint/' + agentId + '/sync_knowledge_repo')
  }

  getGlossary(agentId, data) {
    let params = new HttpParams()
    for (let key in data){
      params = params.set(key, data[key])
    }

    return this.http.get(environment.knowledge_repo_service + agentId + '/acronyms', {params: params})
  }

  addGlossaryItem(agentId, params) {
    return this.http.post(environment.knowledge_repo_service + agentId + '/acronyms', params)
  }

  updateGlossaryItem(agentId, id, params) {
    return this.http.put(environment.knowledge_repo_service + agentId + '/acronyms/' + id, params)
  }

  deleteGlossaryItem(agentId, params) {
    console.log('params---->', params);
    
    return this.http.post(environment.knowledge_repo_service + agentId + '/delete_acronyms', params)
  }

  downloadGlossaryList(agentId) {
    return this.http.get(environment.knowledge_repo_service + agentId + '/download_acronyms_csv')
  }

  uploadGlossaryList(agentId, csv_file) {
    const formData: FormData = new FormData();
    formData.append('csv_file', csv_file, csv_file.name);

    return this.http.post(environment.knowledge_repo_service + agentId + '/upload_acronyms', formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }

  /* ----------- knowledge-integration APIS ---------------- */

  searchArticleId(agentId, searchKey, type) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_documents/' + type + '/' + agentId +
     '/articles/search?word=' + searchKey)
  }

  SearchArticleData(agentId, articleId, type) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_documents/' + type + '/' + agentId + '/get_documents_content/' +  articleId)
  }
  SearchDrupalArticleData(agentId, articleId, type, content_type) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_documents/' + type + '/' + agentId + '/get_documents_content/' +  articleId + '?content_type=' + content_type)
  }
  getDocument(agentId, type, url) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_documents/' + type + '/' + agentId + '/download_content?url=' +  url, {responseType : 'text'})
  }
  importSalesforceDoc(agentId, params, type) {
    return this.http.post(environment.knowledge_repo_service + 'knowledge_documents/' + type + '/' + agentId + '/ingest_article_to_documents', params)
  }

  syncKnowledgeRepository(agentId, type) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_documents/' + type + '/' + agentId + '/sync_documents_repo')
  }

  importS3KnowledgeDoc(agentId) {
    return this.http.post(environment.knowledge_repo_service + 'knowledge_documents/s3_knowledge/' + agentId + '/ingest_s3_article_to_documents', {'repo_type': 's3_knowledge'})
  }

}
